import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';

const ScrollAnimation = () => {
  const [scrollY, setScrollY] = useState(0);
  const controls = useAnimation();

  // Update scroll position on scroll event
  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Define the scroll animation based on scroll position
  useEffect(() => {
    controls.start({
      opacity: 1 - scrollY / 500, // Make the element fade out as the page scrolls
      y: scrollY / 2, // Move the element vertically based on scroll
    });
  }, [scrollY, controls]);

  return (
    <div style={{ height: '150vh' }}> {/* Add extra height to make scrolling visible */}
      <motion.div
        animate={controls}
        transition={{ type: 'spring', stiffness: 100 }}
        style={{
          background: '#3498db',
          width: '200px',
          height: '200px',
          margin: '50px auto',
          textAlign: 'center',
          lineHeight: '200px',
          color: 'white',
        }}
      >
        Scroll Me
      </motion.div>
    </div>
  );
};

export default ScrollAnimation;